import { getParametersFromUrl } from './urlUtils';

export const aditionalParams =
  '&description_url=https%3A//[DOMAIN]/&url=[URL]&correlator=[RANDOM]&sz=400x300|640x300|640x480|640x360|1280x720&gdfp_req=1&min_ad_duration=1000&max_ad_duration=180000&unviewed_position_start=0&output=xml_vast4&env=instream&vpmute=0&nofb=1&tfcd=0&npa=0&vpa=click&vad_type=linear&vpos=preroll&videoad_start_delay=0&ad_type=audio_video&gdpr=[GDPR]&gdpr_consent=[CONSENT]&ppid=[UUID]&scor=[SYCVID]&sdk_apis=2&wta=1&osd=2&sdr=1&is_amp=0&u_so=l&impl=s&sdkv=h.3.500.0&schain=1.0,1!playoncenter.com,[COMPANY_ID],1';

function checkGooglesyndicationTag(tag) {
  return tag.match(/^http(s)?:\/\/(www.)?tpc.googlesyndication.com/);
}

export default function parserTag(tag) {
  if (checkGooglesyndicationTag(tag)) {
    const parameters = getParametersFromUrl(tag);
    if (!parameters.adtagurl) return tag;
    const parameters2 = getParametersFromUrl(parameters.adtagurl);
    const domain = parameters.adtagurl.split('?');
    if (Array.isArray(domain)) {
      const newTag = `${domain[0]}?iu=${parameters2.iu}`;
      return newTag + aditionalParams;
    }
  }
  return tag;
}
